<template>
  <BreadCrumb :crumbs="crumbs" />
  <br />
  <div>
    {{ offerId }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";

import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import { useOffers } from "@/modules/Offers/hooks/useOffers";
import links from "@/router/links";

const props = defineProps({
  gameId: {
    type: String,
    required: true,
  },
  versionId: {
    type: String,
    required: true,
  },
  campaignId: {
    type: String,
    required: false,
  },
  offerId: {
    type: String,
    required: true,
  },
});

const router = useRouter();
const { sortedCampaigns, offersToDisplay } = useOffers(props.gameId, props.versionId);

const displayedCampaign = computed(() => sortedCampaigns.value.find((campaign) => campaign.id === props.campaignId));
const displayedOffer = computed(() => offersToDisplay.value.find((offer) => offer.id === props.offerId));

const redirectToCampaignList = () => {
  router.push({ name: links.offersAndStore.tabs.offerCampaigns.campaignList });
};

const redirectToOffersList = () => {
  router.push({
    name: links.offersAndStore.tabs.offerCampaigns.offerList,
    params: {
      gameId: props.gameId,
      versionId: props.versionId,
      campaignId: props.campaignId,
    },
  });
};

const crumbs = computed(() => [
  { label: "Offer campaigns", action: redirectToCampaignList },
  ...(displayedCampaign.value ? [{ label: displayedCampaign.value.name || "", action: redirectToOffersList }] : []),
  ...(displayedOffer.value ? [{ label: displayedOffer.value.name || "" }] : []),
]);
</script>

<style module lang="scss">
.breadCrumb {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-size: 14px;
  color: var(--vd-color-text-light-2);

  .activeLink {
    color: var(--vd-color-blue-default);
    cursor: pointer;
    font-weight: 600;
  }

  i {
    font-size: 10px;
  }
}
</style>
